<template>
  <div>
    <template v-if="selectedSubjectHasChild && sendApiParams.length > 1">
      <p>他分野の設定設問数</p>
      <p :key="condition.code" class="field" v-for="condition in sendApiParams">
        {{subjectName(condition.code)}}：{{condition.questionNum ? condition.questionNum : 0}}問
      </p>
      <p class="field">設定可能問題数：{{enableInputNum}}問以内</p>
    </template>

    <v-text-field
      style="width:200px"
      v-model="questionNum"
      label="小問数"
      outlined
      :rules="rules"
      color="secondary"
      dense
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import teacher from '../../mixins/teacher';

export default {
  mixins: [teacher],

  data() {
    return {
      rules: [
        value => !value.match(/[^0-9]/) || '数字のみで入力してください',
        value => value <= this.enableInputNum || `${this.enableInputNum}以内で入力してください`,
      ],
    }
  },

  methods: {
    // 全角数字を半角へ変換
    convertHalf(text) {
      return text.replace(/[０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
    },
  },

  computed: {
    ...mapGetters([
      'selectedSubjectHasChild',
      'sendApiParams',
      'maxQuestionNum',
    ]),

    subjectName() {
      return function (code) {
        return this.$store.state.master.allSubjects.find(subject => subject.code === code).name
      }
    },
    // values
    questionNum: {
      get() {
        return this.currentSubjectCondition.questionNum
          ? this.currentSubjectCondition.questionNum
          : '';
      },
      set(value) {
        this.$store.commit('changeCurrentSubjectCondition', { questionNum: this.convertHalf(value) })
      }
    },
    enableInputNum() {
      const totalInputedNum = this.sendApiParams
          ? this.sendApiParams.reduce((accumulator, condition) => {
              if (condition.code === this.currentSubjectCondition.code) return accumulator
              return accumulator + Number(condition.questionNum)
            }, 0)
          : 0
      return this.maxQuestionNum - totalInputedNum
    }
  },
}
</script>

<style lang="stylus" scoped>
  .field
    display inline-block
    margin-left 20px
</style>
